import {useState} from "react"
import {useReportQuarterlyMaintenance} from "./hooks/useReportQuarterlyMaintenance.js"
import moment from "moment"
import Textfield from "../../common/components/Textfiled.jsx"
import { Container, Row, Col, Table } from "react-bootstrap";

const groupedData = (data) => data.reduce((acc, item) => {
  const key = `${item.anio}-T${item.trimestre}`;
  if (!acc[key]) {
    acc[key] = { trimestre: item.trimestre, anio: item.anio, ejecutado: 0, programado: 0 };
  }
  if (item.tipo === "Ejecutado") {
    acc[key].ejecutado = item.total;
  } else if (item.tipo === "Programado") {
    acc[key].programado = item.total;
  }
  return acc;
}, {});

function SubMaintenance(){
  const [filters, setFilters] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(3, "M").format("YYYY-MM-DD"),
  })
  const {report} = useReportQuarterlyMaintenance(filters);

  const handleChange = ({name, value}) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

    return(
     <main>
      <Container>
        <header className="text-center my-1">
          <h1 className="fs-1">Mantenimiento</h1>
        </header>

        <section className="d-flex flex-column">
            <Row className="mb-4">
              <Col md={6}>
                <Textfield
                  label="Fecha inicio"
                  name="startDate"
                  type="date"
                  value={filters.startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col md={6}>
                <Textfield
                  label="Fecha fin"
                  name="endDate"
                  type="date"
                  value={filters.endDate}
                  onChange={handleChange}
                />
              </Col>
            </Row>

          <Table striped bordered hover responsive>
              <thead>
            <tr>
              <th>Año</th>
              <th>Trimestre</th>
              <th>Preventivos Ejecutados</th>
              <th>Preventivos Programados</th>
            </tr>
          </thead>
          <tbody>
            {Object.values(groupedData(report)).map((item, index) => (
              <tr key={index}>
                <td>{item.anio}</td>
                <td>{item.trimestre}</td>
                <td>{item.ejecutado}</td>
                <td>{item.programado}</td>
              </tr>
            ))}
          </tbody>          </Table>
        </section>
      </Container>
    </main>    )
  }

  export default SubMaintenance;
